import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { SystemEvent } from '@app/shared/enums';

import { EventsService, ScriptService } from '@app/shared/services';
import { ConfigService } from '@app/configuration/config.service';
import { GainsightService } from './gainsight.service';

function initialize(scriptService: ScriptService, eventsService: EventsService, configService: ConfigService) {
  const res = () => {
    if (configService.getConfig()?.gainSightPXCode) {
      const scriptName = 'aptrinsic';
      window[scriptName] =
        window[scriptName] ||
        ((...args: any[]) => {
          (window[scriptName]['q'] = window[scriptName]['q'] || []).push(...args);
        });
      window[scriptName]['p'] = configService.getConfig().gainSightPXCode;

      scriptService.loadScript(ScriptService.SCRIPT_NAMES.GAINSIGHT).then(({ loaded }) => {
        if (loaded) {
          eventsService.emit(SystemEvent.GainsightScriptLoaded);
        }
      });
    }
  };

  return res;
}

@NgModule({
  imports: [],
  providers: [
    GainsightService,
    provideAppInitializer(() => {
      const initializerFn = initialize(inject(ScriptService), inject(EventsService), inject(ConfigService));
      return initializerFn();
    })
  ]
})
export class GainsightModule {}
